<template>
  <div>
    <qx-card
      :title="$route.query.type === 'approve' ? '审核' : '客户'"
      class="detail"
      v-loading="loading"
    >
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      >
        <span slot="arriveTime" slot-scope="prop"
          >{{ prop.data.arriveTime / 100 }}小时</span
        >
        <span slot="finePrice" slot-scope="prop"
          >{{ prop.data.finePrice / 100 }}元</span
        >
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      :orderId="originData.orderId"
      v-show="$route.query.type === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="300005"
      :customPost="true"
      @sub="sub"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
    <ApproveBox
      v-if="(type ||$route.query.type) === 'apply'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="300005"
      :customPost="true"
      @sub="sub"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  orderTimeDetail, // 获取详情
  orderTimeCustomerApplyDetail, // 申诉详情
  auditAging, auditAppeal, // 时效审核
} from 'api/operate';
// import Apply from './apply';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    // Apply,
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      loading: false,
      originData: {},
      detailData: {
        base: {
          label: '时效信息',
          tableData: {
            title: [
              {
                prop: 'lineNode',
                label: '时效路段',
              },
              {
                prop: 'orderStartDate',
                label: '离台时间',
              },
              {
                prop: 'orderArriveDate',
                label: '到达时间',
              },
              {
                prop: 'arriveTime',
                label: '运输时间',
                slot: true,
              },
              {
                prop: 'finePrice',
                label: '罚款金额',
                slot: true,
              },
              {
                prop: 'userName',
                label: '责任司机',
              },
              {
                prop: 'auditStsName',
                label: '时效状态',
              },
              {
                prop: 'remark',
                label: '时效描述',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async sub (formData) {
      if (this.$route.query.type === 'apply') {
        const res = await auditAppeal({
          appealId: this.appealId,
          dealFinePrice: this.dealFinePrice,
          state: formData.chooseResult,
          verifyDesc: formData.desc,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        }
      } else if (this.$route.query.type === 'approve') {
        const res = await auditAging({
          agingId: this.$route.query.id || this.id,
          state: formData.chooseResult,
          verifyDesc: formData.desc,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        }
      }
    },
    async getData () {
      if (this.$route.path !== '/manage/operate/order/deal/orderDetailTab/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await orderTimeDetail({
        id: this.id || this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        this.originData = detailRes;
        this.detailData.base.tableData.data = detailRes;
      }
      if (this.$route.query.type === 'apply' || this.id) {
        const applyDetail = await orderTimeCustomerApplyDetail({
          agingId: this.id || this.$route.query.id,
        });
        this.appealId = applyDetail.appealId;
        this.dealFinePrice = (applyDetail.dealFinePrice / 100).toFixed(2);
        this.$set(
          this.detailData, 'apply',
          {
            label: '申诉信息',
            tableData: {
              title: [
                {
                  prop: 'createDate',
                  label: '申诉时间',
                },
                {
                  prop: 'auditStsName',
                  label: '申诉状态',
                },
                {
                  prop: 'remark',
                  label: '申诉原因',
                },
                {
                  prop: 'imgUrlArr',
                  label: '附件',
                  type: 'img',
                  isArray: true,
                },
              ],
              data: applyDetail,
              approveData: {

              },
            },
          }
        );
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
